module.exports = __webpack_public_path__ + "img/button_get_bag.63efa96c.png";